<template>
  <v-col cols="12" class="pb-0 pl-0">
    <header class="pl-4" v-if="!check">
      <v-row align="center">
        <p class="txtHeader2 ma-0">Perfil</p>
        <v-icon v-if="!check" size="medium" color="primary" class="ml-2" @click.stop="helper">
          fas fa-question-circle
        </v-icon>
      </v-row>
    </header>
    <v-row align="center">
      <v-col v-if="check" cols="4" class="d-flex align-center">
        <v-checkbox class="ma-0 custom-checkbox" v-model="model.socioOperador" required>
          <template v-slot:label>
            <div class="d-flex align-center">
              <span class="text-small text-justify" style="color: var(--v-primary-base) !important; font-family: Inter !important;">
                Cadastrar como operador
              </span>
              <v-icon size="medium" color="primary" class="ml-2" @click.stop="helper">
                fas fa-question-circle
              </v-icon>
            </div>
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="4" v-if="showTipoPerfil">
        <input-select v-model="model.perfil" label="Perfil do operador"
          :options="perfilOptions"
          required
          :disabled="disable"
          @change="$emit('changeCheckOperador', model.socioOperador)"
          item-value="codigo"
          item-text="descricaoTipoPerfilFrontEnd"/>
      </v-col>
    </v-row>
    <ModalHelper ref="helper"/>
  </v-col>
</template>
<script>
export default {
  components: {
    ModalHelper: () => import('../views/Modais/ModalHelper.vue'),
  },
  props: {
    value: null,
    check: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false
    },
    codigoParceiro: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      perfilOptions: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    showTipoPerfil () {
      return !this.check || this.model.perfil?.length > 0 ? true : this.model.socioOperador ?? false
    }
  },
  methods: {
    setValue (value) {
      this.$set(this, 'model', value)
    },
    helper () {
      this.$refs.helper.openModal()
    },
    buscarPerfis () {
      const th = this
      if (th.$store.getters['onboarding/paramNovoIb']) {
        th.perfilOptions = [
          { descricaoTipoPerfilFrontEnd: 'Master', codigo: 1 }
        ]
      } else {
        const codigoParceiro = th.$empresa.codigoParceiro || th.codigoParceiro
        const path = `operadores-front-end/perfis/${codigoParceiro}`
        th.$api.Dbs.Get(path).then(response => {
          if (response.success) {
            th.perfilOptions = response.response
          }
        })
      }
    },
    setCheckPerfil (status) {
      this.$set(this.model, 'socioOperador', status)
    }
  },
  created () {
    const th = this
    th.buscarPerfis()
    if (this.model.perfil?.length > 0) {
      this.model.socioOperador = true
    }
  }
}
</script>
<style scoped>
  .txtHeader2{
    font-weight: 600;
    font-size: 16px;
  }
</style>
